// extracted by mini-css-extract-plugin
export default {"link":"ExternalLink_link__8aQKa"};